<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__update-item idea-activity-update"
  >
    <template #pic>
      <div class="label-pic is-yellow">
        <icon
          data="@icon/idea.svg"
          class="label-pic__icon idea-activity-update__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>

    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          v-if="notification.ideaUrl"
          :href="notification.ideaUrl"
          class="link is-large"
          target="_blank"
          rel="noopener noreferrer"
        >
          Idea {{ notification.ideaKey }}
        </a>
        <span
          v-else
          class="idea-activity-update__key"
          >Idea {{ notification.ideaKey }}</span
        >
        {{ changedLabel }} has been updated by
        <span class="notification__update-item__initiator idea-activity-update__initiator"
          >@{{ notification.initiatorFullName }}</span
        >
      </BaseSubHeading>
    </template>

    <template #content>
      <slot />
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationIdeaActivity } from "@/models/Notification"

/** Shared heading for every "Idea <field> has been updated by @user" card. */
defineProps<{
  notification: NotificationIdeaActivity
  changedLabel: string
}>()
</script>

<style lang="scss" scoped>
.idea-activity-update__icon {
  :deep(path) {
    fill: var(--markingYellow-03);
  }
}

// Matches `.link.is-large`, so the key keeps its size when there is no url to link to.
.idea-activity-update__key {
  color: var(--accent-03);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-md);
  line-height: var(--line-height-lg);

  .dark & {
    color: var(--accent-200);
  }
}
</style>
